export const getCampaignId = state => state.campaign.get('campaignId');
export const getCampaignName = state => state.campaign.getIn(['campaign', 'name']);
export const getCampaignLoading = state => state.campaign.get('campaignLoading');
export const getPermissionId = state => state.campaign.get('myPermissionId');
export const getTeamDiscussionId = state => state.campaign.get('teamDiscussionId');
export const getClientDiscussionId = state => state.campaign.get('clientDiscussionId');
export const getPartnerAgencyDiscussionId = state => state.campaign.get('partnerAgencyDiscussionId');
export const getTeamOrganisationId = state => state.campaign.get('teamOrganisationId');

// Extracts members by role, ignores the logged in user.
export const getRoleMembers = (state, roles) => {
  const members = state.campaign.get('members');
  const myPermissionId = state.campaign.get('myPermissionId');
  const roleMembers = [];
  members.forEach(member => {
    const exists = roles.find(role => { return role === member.get('role'); });
    if (exists && myPermissionId !== member.get('id')) {
      roleMembers.push({ permissionId: member.get('id'), userId: member.getIn(['user', 'id']), name: member.get('name') });
    }
  });
  return roleMembers;
};



/** WEBPACK FOOTER **
 ** ./src/selectors/campaign-selectors.js
 **/